<template>
  <div>
    <div class="d-flex justify-content-between align-items-center pt-50 mb-2">
      <h2 class="font-weight-bolder m-0">
        <span @click="$router.go(-1)">
          <b-button
              variant="white"
              class="btn-icon rounded-circle mr-50 text-primary bg-white"
              size="sm"
          >
            <feather-icon icon="ChevronLeftIcon" />
          </b-button>
        </span>
        Horarios
      </h2>
      <b-button
          variant="primary"
          class="ml-2"
          @click="onAddSchedule"
      >
        Añadir horario
      </b-button>
    </div>
    <div class="mb-3">
      <template v-if="schedules && schedules.length">
        <b-row>
          <b-col
            v-for="schedule in schedules"
            :key="schedule.id"
            cols="12"
            md="6"
            class="mb-2"
          >
            <b-card
              class="h-100"
              :class="{ 'border-primary': schedule.is_default }"
            >
              <div class="d-flex justify-content-between align-items-start mb-1">
                <div>
                  <h4 class="mb-0">
                    {{ schedule.name || 'Horario sin nombre' }}
                  </h4>
                  <div class="mt-50">
                    <b-badge
                      v-if="schedule.is_active"
                      variant="success"
                      class="mr-50"
                    >
                      Activo
                    </b-badge>
                    <b-badge
                      v-if="schedule.is_default"
                      variant="primary"
                    >
                      Por defecto
                    </b-badge>
                  </div>
                </div>
                <b-dropdown
                  variant="link"
                  no-caret
                  toggle-class="p-0"
                  right
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="18"
                      class="text-body"
                    />
                  </template>
                  <b-dropdown-item v-if="!schedule.is_default" @click="toggleScheduleActive(schedule)">
                    <feather-icon
                      :icon="schedule.is_active ? 'ToggleRightIcon' : 'ToggleLeftIcon'"
                      size="16"
                    />
                    <span class="ml-50">{{ schedule.is_active ? 'Desactivar' : 'Activar' }}</span>
                  </b-dropdown-item>
                  <b-dropdown-item v-if="!schedule.is_default" @click="toggleScheduleDefault(schedule)">
                    <feather-icon
                      :icon="schedule.is_default ? 'StarIcon' : 'StarIcon'"
                      size="16"
                      :class="schedule.is_default ? 'text-warning' : ''"
                    />
                    <span class="ml-50">{{ schedule.is_default ? 'Quitar por defecto' : 'Hacer por defecto' }}</span>
                  </b-dropdown-item>
                  <b-dropdown-divider v-if="!schedule.is_default" />
                  <b-dropdown-item @click="onViewScheduleUsers(schedule)">
                    <feather-icon icon="UsersIcon" size="16" />
                    <span class="ml-50">Ver usuarios</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="onEditSchedule(schedule)">
                    <feather-icon
                      icon="EditIcon"
                      size="16"
                    />
                    <span class="ml-50">Editar</span>
                  </b-dropdown-item>
                  <b-dropdown-divider />
                  <b-dropdown-item
                    variant="danger"
                    @click="onDeleteSchedule(schedule)"
                  >
                    <feather-icon
                      icon="TrashIcon"
                      size="16"
                    />
                    <span class="ml-50">Eliminar</span>
                  </b-dropdown-item>
                </b-dropdown>
              </div>

              <b-card-text class="mt-1">
                <div class="d-flex align-items-center mb-75">
                  <feather-icon
                    icon="ClockIcon"
                    size="16"
                    class="text-muted mr-50"
                  />
                  <span class="font-weight-bold">Tipo de jornada:</span>
                  <span class="ml-50 text-capitalize">{{ schedule.type || 'continua' }}</span>
                </div>

                <div
                  v-if="schedule.work_days && schedule.work_days.length > 0"
                  class="d-flex align-items-center"
                >
                  <feather-icon
                    icon="CalendarIcon"
                    size="16"
                    class="text-muted mr-50"
                  />
                  <span class="font-weight-bold">Días laborables:</span>
                  <span class="ml-50">{{ schedule.work_days.length }} días</span>
                </div>
              </b-card-text>
            </b-card>
          </b-col>
        </b-row>
      </template>
      <template v-else>
        <b-card>
          <div class="text-center text-muted py-3">
            Aún no se ha creado ningún horario.
          </div>
        </b-card>
      </template>
    </div>
    <b-card>
      <!-- form de calendario, ya no se gestiona jornada ni days aquí -->
      <validation-observer ref="editCalendar">
        <b-form
            class="mt-2"
            @submit.prevent="handleSubmit"
            @keydown.enter="handleSubmit"
        >
          <b-row>
            <b-col cols="12">
              <p><strong>Configuración</strong></p>
            </b-col>
            <b-col
                sm="3"
                class="mt-1"
            >
              <b-form-group>
                <b-form-checkbox
                    v-model="enable_check_in_reason"
                    class="mb-1"
                >
                  Activar petición motivo entrada tardía
                </b-form-checkbox>
              </b-form-group>
              <validation-provider
                  v-if="enable_check_in_reason"
                  #default="{ errors }"
                  :name="'Tiempo que se permite fichar sin motivo'"
                  rules="required"
              >
                <b-form-group
                    :label="'Tiempo que se permite fichar sin motivo'"
                    label-for="calendar-mins_of_schedule_check_in"
                >
                  <b-form-timepicker
                      v-model="mins_of_schedule_check_in"
                      local="es"
                      :no-close-button="true"
                      :hide-header="true"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col
                sm="3"
                class="mt-1"
            >
              <b-form-group>
                <b-form-checkbox
                    v-model="enable_check_out_reason"
                    class="mb-1"
                >
                  Activar petición motivo salida tardía
                </b-form-checkbox>
              </b-form-group>
              <validation-provider
                  v-if="enable_check_out_reason"
                  #default="{ errors }"
                  :name="'Tiempo que se permite cerrar jornada sin motivo'"
                  rules="required"
              >
                <b-form-group
                    :label="'Tiempo que se permite cerrar jornada sin motivo'"
                    label-for="calendar-mins_of_schedule_check_out"
                >
                  <b-form-timepicker
                      v-model="mins_of_schedule_check_out"
                      local="es"
                      :no-close-button="true"
                      :hide-header="true"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12 text-right">
              <b-button
                  type="submit"
                  variant="primary"
                  class="mt-2 mr-1"
              >
                {{ 'Guardar' }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>

      <div class="d-flex justify-content-between align-items-center mb-2">
        <p class="font-weight-bold m-0">
          Agrupaciones de horarios
        </p>
        <b-button
          variant="primary"
          @click="onAddScheduleGroup"
        >
          Añadir agrupación
        </b-button>
      </div>
      <template v-if="scheduleGroups && scheduleGroups.length">
        <b-row>
          <b-col
            v-for="group in scheduleGroups"
            :key="group.id"
            cols="12"
            md="6"
            class="mb-2"
          >
            <b-card class="h-100 mb-0">
              <div class="d-flex justify-content-between align-items-start">
                <div>
                  <h5 class="mb-25">{{ group.name }}</h5>
                  <b-badge :variant="group.is_active ? 'success' : 'secondary'">
                    {{ group.is_active ? 'Activo' : 'Inactivo' }}
                  </b-badge>
                  <p v-if="group.description" class="mt-75 mb-0 text-muted small">
                    {{ group.description }}
                  </p>
                </div>
                <b-dropdown variant="link" no-caret toggle-class="p-0" right>
                  <template #button-content>
                    <feather-icon icon="MoreVerticalIcon" size="18" class="text-body" />
                  </template>
                  <b-dropdown-item @click="onViewGroupUsers(group)">
                    <feather-icon icon="UsersIcon" size="16" />
                    <span class="ml-50">Ver usuarios</span>
                  </b-dropdown-item>
                  <b-dropdown-item @click="onEditScheduleGroup(group)">
                    <feather-icon icon="EditIcon" size="16" />
                    <span class="ml-50">Editar</span>
                  </b-dropdown-item>
                  <b-dropdown-divider />
                  <b-dropdown-item variant="danger" @click="onDeleteScheduleGroup(group)">
                    <feather-icon icon="TrashIcon" size="16" />
                    <span class="ml-50">Eliminar</span>
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </template>
      <template v-else>
        <div class="text-center text-muted py-2">
          Aún no se ha creado ninguna agrupación.
        </div>
      </template>

    <schedule-sidebar
        :visible.sync="showScheduleSidebar"
        :editing-schedule="editingSchedule"
        :days-of-week="daysOfWeek"
        :initial-form="scheduleSidebarForm"
        @submit="handleScheduleSidebarSubmit"
    />

    <schedule-group-modal
        :visible.sync="showScheduleGroupModal"
        :client-id="currentClient.id"
        :editing-group="editingGroup"
        @submit="handleScheduleGroupSubmit"
    />

    <b-modal
      v-model="showGroupUsersModal"
      :title="`Usuarios — ${selectedGroupName}`"
      ok-only
      ok-title="Cerrar"
    >
      <template v-if="scheduleGroupUsers && scheduleGroupUsers.length">
        <b-list-group flush>
          <b-list-group-item
            v-for="u in scheduleGroupUsers"
            :key="u.id"
            :to="`/admin/users/view/${u.id}`"
            class="d-flex align-items-center px-0"
          >
            <b-avatar
              :src="u.avatar_url"
              :text="u.name ? u.name.charAt(0) : '?'"
              size="32"
              class="mr-1"
            />
            <span>{{ u.name }} {{ u.surname }}</span>
          </b-list-group-item>
        </b-list-group>
      </template>
      <template v-else>
        <div class="text-center text-muted py-2">
          Ningún usuario asignado.
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  BButton, BForm, BFormGroup, BRow, BCol, BCard, BFormTimepicker, BFormCheckbox,
  BBadge, BDropdown, BDropdownItem, BDropdownDivider, BCardText,
  BModal, BListGroup, BListGroupItem, BAvatar,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import ScheduleSidebar from './ScheduleSidebar.vue'
import ScheduleGroupModal from './ScheduleGroupModal.vue'

export default {
  components: {
    BFormCheckbox,
    BButton,
    BForm,
    BFormGroup,
    BRow,
    BCol,
    BCard,
    BBadge,
    BDropdown,
    BDropdownItem,
    BDropdownDivider,
    BCardText,
    BModal,
    BListGroup,
    BListGroupItem,
    BAvatar,
    ValidationProvider,
    ValidationObserver,
    BFormTimepicker,
    ScheduleSidebar,
    ScheduleGroupModal,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      mins_of_schedule_check_in: '',
      mins_of_schedule_check_out: '',
      enable_check_in_reason: false,
      enable_check_out_reason: false,
      date_ini: '',
      date_fin: '',
      date_almuerzo: '',
      date_comida: '',
      min_alert_finish: '',
      annual_vacation_days: 0,
      accumulable_days: false,
      required,
      email,
      showScheduleSidebar: false,
      showScheduleGroupModal: false,
      showGroupUsersModal: false,
      editingGroup: null,
      selectedGroupName: '',
      editingSchedule: null,
      scheduleSidebarForm: {
        name: '',
        type: 'continua',
        active: true,
        is_active: 0,
        is_default: 0,
        days: {
          monday: {
            enabled: true, start_time: '', end_time: '', start_time2: '', end_time2: '', restMinutes: 0,
          },
          tuesday: {
            enabled: true, start_time: '', end_time: '', start_time2: '', end_time2: '', restMinutes: 0,
          },
          wednesday: {
            enabled: true, start_time: '', end_time: '', start_time2: '', end_time2: '', restMinutes: 0,
          },
          thursday: {
            enabled: true, start_time: '', end_time: '', start_time2: '', end_time2: '', restMinutes: 0,
          },
          friday: {
            enabled: true, start_time: '', end_time: '', start_time2: '', end_time2: '', restMinutes: 0,
          },
          saturday: {
            enabled: false, start_time: '', end_time: '', start_time2: '', end_time2: '', restMinutes: 0,
          },
          sunday: {
            enabled: false, start_time: '', end_time: '', start_time2: '', end_time2: '', restMinutes: 0,
          },
        },
      },
      daysOfWeek: [
        { key: 'monday', label: 'Lunes' },
        { key: 'tuesday', label: 'Martes' },
        { key: 'wednesday', label: 'Miércoles' },
        { key: 'thursday', label: 'Jueves' },
        { key: 'friday', label: 'Viernes' },
        { key: 'saturday', label: 'Sábado' },
        { key: 'sunday', label: 'Domingo' },
      ],
    }
  },
  computed: {
    ...mapGetters({
      calendar: 'calendar/getConfigCalendar',
      currentClient: 'clients/getCurrentClient',
      canEditModuleVacations: 'clients/getCanEditModuleVacations',
      schedules: 'schedule/getSchedules',
      scheduleGroups: 'schedule/getScheduleGroups',
      scheduleGroupUsers: 'schedule/getScheduleGroupUsers',
    }),
  },
  methods: {
    ...mapActions({
      edit: 'calendar/edit',
      getCalendar: 'calendar/getConfigCalendar',
      listSchedules: 'schedule/listSchedules',
      deleteSchedule: 'schedule/deleteSchedule',
      updateSchedule: 'schedule/updateSchedule',
      createSchedule: 'schedule/createSchedule',
      createGroupSchedule: 'schedule/createGroupSchedule',
      listScheduleGroups: 'schedule/listScheduleGroups',
      updateGroupSchedule: 'schedule/updateGroupSchedule',
      deleteGroupSchedule: 'schedule/deleteGroupSchedule',
      getGroupScheduleUsers: 'schedule/getGroupScheduleUsers',
      getScheduleUsers: 'schedule/getScheduleUsers',
    }),
    handleSubmit() {
      this.$refs.editCalendar.validate().then(success => {
        if (success) {
          const formData = this.createFormData()
          if (formData) {
            this.edit({ calendar: formData })
          }
        }
      })
    },
    setData() {
      this.date_fin = (this.calendar.hour_fin) ? this.calendar.hour_fin : '00:00:00'
      this.date_ini = (this.calendar.hour_ini) ? this.calendar.hour_ini : '00:00:00'
      this.mins_of_schedule_check_in = (this.calendar.mins_of_schedule_check_in) ? this.calendar.mins_of_schedule_check_in : '00:00:00'
      this.mins_of_schedule_check_out = (this.calendar.mins_of_schedule_check_out) ? this.calendar.mins_of_schedule_check_out : '00:00:00'
      this.date_almuerzo = (this.calendar.min_breakfast) ? this.calendar.min_breakfast : '00:00:00'
      this.date_comida = (this.calendar.min_lunch) ? this.calendar.min_lunch : '00:00:00'
      this.min_alert_finish = (this.calendar.min_alert_finish) ? this.calendar.min_alert_finish : '00:00:00'

      // Activar checkboxes si los valores son diferentes de '00:00:00'
      this.enable_check_in_reason = this.mins_of_schedule_check_in !== '00:00:00'
      this.enable_check_out_reason = this.mins_of_schedule_check_out !== '00:00:00'
    },
    createFormData() {
      const data = new FormData()
      data.append('accumulable_days', this.accumulable_days)
      data.append('annual_vacation_days', this.annual_vacation_days)
      data.append('vacation_days_type', this.vacation_days_type)
      data.append('type_journey', this.typeJourney)
      data.append('min_breakfast', this.date_almuerzo)
      data.append('min_lunch', this.date_comida)
      data.append('hour_fin', this.date_fin)
      data.append('hour_ini', this.date_ini)
      data.append('mins_of_schedule_check_in', this.enable_check_in_reason ? this.mins_of_schedule_check_in : '00:00:00')
      data.append('mins_of_schedule_check_out', this.enable_check_out_reason ? this.mins_of_schedule_check_out : '00:00:00')
      data.append('min_alert_finish', this.min_alert_finish)
      data.append('client_id', this.currentClient.id)

      return data
    },
    onAddSchedule() {
      this.editingSchedule = null
      this.scheduleSidebarForm = {
        name: '',
        type: 'continua',
        active: true,
        is_active: 0,
        is_default: 0,
        days: {
          monday: {
            enabled: true, start_time: '', end_time: '', start_time2: '', end_time2: '', restMinutes: 0,
          },
          tuesday: {
            enabled: true, start_time: '', end_time: '', start_time2: '', end_time2: '', restMinutes: 0,
          },
          wednesday: {
            enabled: true, start_time: '', end_time: '', start_time2: '', end_time2: '', restMinutes: 0,
          },
          thursday: {
            enabled: true, start_time: '', end_time: '', start_time2: '', end_time2: '', restMinutes: 0,
          },
          friday: {
            enabled: true, start_time: '', end_time: '', start_time2: '', end_time2: '', restMinutes: 0,
          },
          saturday: {
            enabled: false, start_time: '', end_time: '', start_time2: '', end_time2: '', restMinutes: 0,
          },
          sunday: {
            enabled: false, start_time: '', end_time: '', start_time2: '', end_time2: '', restMinutes: 0,
          },
        },
      }
      this.showScheduleSidebar = true
    },
    onEditSchedule(schedule) {
      let days = {}
      // Si schedule.days es un array (formato API), transformarlo
      if (Array.isArray(schedule.days)) {
        days = this.arrayToDaysObject(schedule.days)
      } else if (Array.isArray(schedule.work_days)) {
        // Si la API devuelve work_days como array
        days = this.arrayToDaysObject(schedule.work_days)
      } else if (schedule.days) {
        days = JSON.parse(JSON.stringify(schedule.days))
      } else if (schedule.week) {
        Object.keys(schedule.week).forEach(dayKey => {
          const d = schedule.week[dayKey]
          days[dayKey] = {
            enabled: d.work,
            start_time: d.entry || '',
            end_time: d.exit || '',
            start_time2: d.breakStart || '',
            end_time2: d.breakEnd || '',
            restMinutes: d.restMinutes || 0,
          }
        })
      }
      // Si schedule.days o work_days es un array vacío, asegúrate de inicializar todos los días
      if (Object.keys(days).length === 0) {
        days = this.arrayToDaysObject([])
      }
      this.editingSchedule = schedule
      this.scheduleSidebarForm = {
        name: schedule.name || '',
        type: schedule.type || 'continua',
        active: schedule.active !== undefined ? schedule.active : true,
        is_active: schedule.is_active !== undefined ? schedule.is_active : 0,
        is_default: schedule.is_default !== undefined ? schedule.is_default : 0,
        days,
      }
      this.showScheduleSidebar = true
    },
    async handleScheduleSidebarSubmit(form) {
      const payload = {
        ...form,
        client_id: this.currentClient.id,
      }
      if (this.editingSchedule) {
        await this.updateSchedule({ id: this.editingSchedule.id, data: payload })
      } else {
        await this.createSchedule(payload)
      }
      this.showScheduleSidebar = false
      await this.listSchedules({ client_id: this.currentClient.id })
    },
    async onDeleteSchedule(schedule) {
      if (!schedule.is_default) {
        this.$bvModal
          .msgBoxConfirm(`¿Estás seguro de eliminar ${schedule.name || 'este horario'}?`, {
            bodyClass: 'bodyDelete',
            footerClass: 'footerDelete',
            okVariant: 'danger',
            okTitle: 'Eliminar',
            cancelTitle: 'Cancelar',
            cancelVariant: 'outline-danger',
            centered: true,
          })
          .then(async value => {
            if (value === true) {
              // Aseguramos que el id sea un número y no un objeto
              const id = typeof schedule.id === 'object' ? schedule.id.id : schedule.id
              await this.deleteSchedule( id )
              await this.listSchedules({ client_id: this.currentClient.id })
            }
          })
      } else {
        this.$store.commit('notifications', {
          title: 'No se puede eliminar el horario por defecto',
          variant: 'danger',
        }, { root: true })
        this.$store.commit('setShowNotifications', true, { root: true })
      }
    },
    async toggleScheduleActive(schedule) {
      // Alternar el estado de is_active del horario seleccionado
      const newValue = schedule.is_active === true ? 0 : 1
      await this.updateSchedule({ id: schedule.id, data: { is_active: newValue } })
      await this.listSchedules({ client_id: this.currentClient.id })
    },
    async toggleScheduleDefault(schedule) {
      // Alternar el estado de is_default del horario seleccionado
      // El backend se encarga de quitar is_default de los otros horarios
      const newValue = schedule.is_default === true ? 0 : 1
      await this.updateSchedule({ id: schedule.id, data: { is_default: newValue } })
      await this.listSchedules({ client_id: this.currentClient.id })
    },

    async onViewScheduleUsers(schedule) {
      this.selectedGroupName = schedule.name || 'Horario'
      await this.getScheduleUsers(schedule.id)
      this.showGroupUsersModal = true
    },
    async onViewGroupUsers(group) {
      this.selectedGroupName = group.name
      await this.getGroupScheduleUsers(group.id)
      this.showGroupUsersModal = true
    },
    onAddScheduleGroup() {
      this.editingGroup = null
      this.showScheduleGroupModal = true
    },
    onEditScheduleGroup(group) {
      this.editingGroup = group
      this.showScheduleGroupModal = true
    },
    async onDeleteScheduleGroup(group) {
      this.$bvModal
        .msgBoxConfirm(`¿Estás seguro de eliminar la agrupación "${group.name}"?`, {
          bodyClass: 'bodyDelete',
          footerClass: 'footerDelete',
          okVariant: 'danger',
          okTitle: 'Eliminar',
          cancelTitle: 'Cancelar',
          cancelVariant: 'outline-danger',
          centered: true,
        })
        .then(async value => {
          if (value === true) {
            await this.deleteGroupSchedule(group.id)
            await this.listScheduleGroups({ client_id: this.currentClient.id })
          }
        })
    },
    async handleScheduleGroupSubmit(payload) {
      if (this.editingGroup) {
        await this.updateGroupSchedule({ id: this.editingGroup.id, data: payload })
      } else {
        await this.createGroupSchedule(payload)
      }
      this.showScheduleGroupModal = false
      this.editingGroup = null
      await this.listScheduleGroups({ client_id: this.currentClient.id })
    },
    arrayToDaysObject(array) {
      const daysOfWeek = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
      const days = {}
      daysOfWeek.forEach(day => {
        // Busca el primer objeto del array para ese día
        const found = array.find(item => item.day_of_week === day)
        days[day] = {
          enabled: found ? !!found.enabled : false,
          start_time: found && found.start_time ? found.start_time : '',
          end_time: found && found.end_time ? found.end_time : '',
          start_time2: found && found.start_time2 ? found.start_time2 : '',
          end_time2: found && found.end_time2 ? found.end_time2 : '',
          restMinutes: found && found.restMinutes ? found.restMinutes : 0,
        }
      })
      return days
    },
  },
  async created() {
    await this.getCalendar(this.currentClient.id)
    await this.setData()
    await this.listSchedules({ client_id: this.currentClient.id })
    await this.listScheduleGroups({ client_id: this.currentClient.id })
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
